module.exports = __webpack_public_path__ + "static/media/soci.48df832f.svg";